import React, { useState, useEffect, useMemo } from 'react';
import { 
  Search, Building2, ShoppingBag, History, Users, 
  Send, MessageSquare, Clock, ExternalLink, Plus, RefreshCw, UserCircle, X, FileUp, Upload, Wrench,
  Edit2, Trash2, Download, FileText, FolderOpen // 🚨 [추가] 파일 보관함을 위한 아이콘 추가
} from 'lucide-react';
import { API_BASE_URL } from '../config';

import CSActivityModal from './CSActivityModal'; //  CS 활동 등록 모달 컴포넌트
import PermissionGate from './PermissionGate'; // 🚨 [추가] 자물쇠 마법상자 불러오기
import { crmDataService } from '../services/crmDataService'; // 🚨 [추가] 서비스 연결

export default function CompanyList({ globalRefreshKey = 0, onNavigate, currentUser }: any) { // 🚨 [수정] currentUser 추가로 받음
  // 🚨 [추가] 3가지 소스 데이터를 담을 상태값으로 확장
  const [orders, setOrders] = useState<any[]>([]);
  const [deals, setDeals] = useState<any[]>([]);
  const [contactsMaster, setContactsMaster] = useState<any[]>([]);
  
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClientId, setSelectedClientId] = useState<number | string | null>(null);
  const [selectedClientName, setSelectedClientName] = useState(''); 
  const [clientDetail, setClientDetail] = useState<any>(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [quickMemo, setQuickMemo] = useState("");

  //피드 수정
  const [editingHistoryId, setEditingHistoryId] = useState<number | null>(null); // 수정 중인 메모 ID
  const [editHistoryContent, setEditHistoryContent] = useState(""); // 수정 중인 글자 내용

  const [isCSMode, setIsCSMode] = useState(false); // 피드 토글용
  const [showCSModal, setShowCSModal] = useState(false); // 새로 만든 모달 띄우기용

  // 🚨 [신규 추가] 엑셀 업로드 모달을 위한 상태값 (SalesForecast.tsx와 동일)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  // 🚨 [신규 추가] 거래처 파일함 관련 상태
  const [clientFiles, setClientFiles] = useState<any[]>([]);
  const [isDragging, setIsDragging] = useState(false);
  const [showFileCabinet, setShowFileCabinet] = useState(false); // 👈 파일함 숨김/펼침 상태

  // 🚨 [신규 추가] 주문 직접 입력을 위한 모달 상태 및 데이터 바구니
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [newOrder, setNewOrder] = useState({
    order_no: '',
    order_date: new Date().toISOString().split('T')[0], // 기본 오늘 날짜
    client_name: '',
    manager_name: '',
    note: '',
    win_price: 0 // 🚨 [추가] 금액 입력 필드
  });

  // 🚨 [기능 추가] 거래처 및 주문서 수정을 위한 상태 관리
  const [showEditClientModal, setShowEditClientModal] = useState(false);
  const [editClientData, setEditClientData] = useState({ id: 0, client_name: '', region: '' });

  const [showEditOrderModal, setShowEditOrderModal] = useState(false);
  const [editOrderData, setEditOrderData] = useState<any>({ id: 0, order_no: '', order_date: '', manager_name: '', note: '', win_price: 0 }); // 🚨 [추가] 금액 필드 포함

  // 🚨 [신규 추가] 모달에서 [업로드하기] 버튼을 눌렀을 때 실행되는 함수
  const handleConfirmUpload = async () => {
    if (!uploadFile) {
      alert('엑셀 파일을 선택해주세요.');
      return;
    }

    const lower = uploadFile.name.toLowerCase();
    if (!(lower.endsWith('.xlsx') || lower.endsWith('.xls'))) {
      alert('엑셀 파일(.xlsx, .xls)만 업로드할 수 있습니다.');
      return;
    }

    const formData = new FormData();
    formData.append('file', uploadFile);
    formData.append('target', 'orders'); // 백엔드의 TARGET_PATHS["orders"]와 매칭

    setIsUploading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/files/upload-excel`, {
        method: 'POST',
        body: formData,
      });

      if (res.ok) {
        alert("주문서 엑셀 업로드가 완료되었습니다.\n서버 재시작 시 자동으로 반영됩니다.");
        setIsUploadModalOpen(false);
        setUploadFile(null);
        fetchAllData(); // 업로드 후 리스트 갱신
      } else {
        const errData = await res.json();
        alert(`업로드 실패: ${errData.detail || '오류 발생'}`);
      }
    } catch (error) {
      alert("서버 연결 오류가 발생했습니다.");
    } finally {
      setIsUploading(false);
    }
  };

  // 🚨 [신규 추가] 파일 드롭 핸들러 (드래그앤드롭 업로드)
  const handleFileDrop = async (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    // 🛡️ 2중 크로스체크
    if (!window.confirm(`[${file.name}] 파일을 거래처 '${selectedClientName}'에 업로드하시겠습니까?`)) {
      return;
    }

    try {
      setDetailLoading(true);
      // 🚨 [수정] 생 fetch 대신 crmDataService 사용
      const res = await crmDataService.uploadClientFile(
        selectedClientName, 
        file, 
        currentUser?.name || '관리자'
      );
      
      if (res.status === 'success') {
        alert("파일 업로드가 완료되었습니다.");
        handleClientClick(selectedClientId!, selectedClientName); // 상세정보 다시 불러오기
      } else {
        alert(`파일 업로드 실패: ${res.message || '알 수 없는 오류'}`);
      }
    } catch (error) { 
      console.error(error); 
    } finally { 
      setDetailLoading(false); 
    }
  };

  // 🚨 [신규 추가] 파일 삭제 핸들러
  const handleDeleteFile = async (filePath: string, fileName: string) => {
    if (!window.confirm(`[${fileName}] 파일을 정말 삭제하시겠습니까?\n(삭제 후 복구할 수 없습니다)`)) {
      return;
    }

    try {
      setDetailLoading(true);
      const res = await crmDataService.deleteClientFile(filePath);
      
      if (res.status === 'success') {
        alert("파일이 삭제되었습니다.");
        handleClientClick(selectedClientId!, selectedClientName); // 리스트 새로고침
      } else {
        alert(`파일 삭제 실패: ${res.message || '알 수 없는 오류'}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDetailLoading(false);
    }
  };

  // 🚨 [변경] 주문서만 가져오던 것을 3개(주문서, 매출예정표, 고객명단) 동시에 가져오도록 수정
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [ordRes, dealRes, contRes] = await Promise.all([
        fetch(`${API_BASE_URL}/orders`).catch(() => ({ json: () => [] })),
        fetch(`${API_BASE_URL}/forecast/list`).catch(() => ({ json: () => [] })), // 🚨 404 에러 나던 부분 깔끔하게 수정!
        fetch(`${API_BASE_URL}/contacts`).catch(() => ({ json: () => [] }))
      ]);
      const ordData = await ordRes.json();
      const dealData = await dealRes.json();
      const contData = await contRes.json();

      setOrders(Array.isArray(ordData) ? ordData : []);
      setDeals(Array.isArray(dealData) ? dealData : []);
      setContactsMaster(Array.isArray(contData) ? contData : []);
    } catch (error) { 
      console.error(error); 
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => { fetchAllData(); }, [globalRefreshKey]);

  // 🚨 [변경] 3개의 데이터를 섞어서 중복 없는 리스트 생성 (지역 덮어쓰기 로직 포함)
  const uniqueClients = useMemo(() => {
    const clientMap = new Map();
    
    // 1. 주문서 데이터 (가장 먼저 바닥에 깔아둠)
    orders.forEach(order => {
      const name = (order.client_name || order.거래처명 || order.거래처)?.trim();
      if (!name) return;
      
      let r = (order.region || order.지역 || '').trim();
      if (r === '-') r = ''; // '-' 기호는 빈칸으로 취급

      if (!clientMap.has(name)) {
        clientMap.set(name, { id: order.client_id, client_name: name, order_count: 0, region: r, has_deal: false });
      }
      clientMap.get(name).order_count += 1;
      if (r) clientMap.get(name).region = r; // 일단 주문서 지역으로 채움
    });

    // 2. 매출예정표 = 딜보드 (🟢 진행중 영업 ON, 🗺️ 지역 1순위 덮어쓰기!)
    deals.forEach(d => {
      const name = (d.company_name || d.거래처)?.trim();
      if (!name) return;
      
      let r = (d.region || d.지역 || '').trim();
      if (r === '-') r = '';

      if (!clientMap.has(name)) {
        clientMap.set(name, { id: `deal_${d.id}`, client_name: name, order_count: 0, region: r, has_deal: true });
      } else {
        clientMap.get(name).has_deal = true; // 🟢 딜보드에 있으니 초록불 ON!
        if (r) clientMap.get(name).region = r; // 🚨 무조건 딜보드 지역으로 덮어쓰기! (1순위)
      }
    });

    // 3. 고객관리 (🗺️ 지역 빈칸 채우기용 - 2순위)
    contactsMaster.forEach(c => {
      const name = (c.company || c.company_name || c.거래처)?.trim();
      if (!name) return;
      
      let r = (c.region || c.지역 || '').trim();
      if (r === '-') r = '';

      if (!clientMap.has(name)) {
        clientMap.set(name, { id: `cont_${c.id}`, client_name: name, order_count: 0, region: r, has_deal: false });
      } else {
        // 🚨 핵심: 기존에 지역 정보가 비어있을 때만! 고객관리 지역으로 채워넣음 (기존 딜보드 데이터 보호)
        if (!clientMap.get(name).region && r) {
          clientMap.get(name).region = r;
        }
      }
    });

    return Array.from(clientMap.values()).filter(c => 
      c.client_name.toLowerCase().includes(searchTerm.toLowerCase())
    ).sort((a, b) => a.client_name.localeCompare(b.client_name)); // 가나다순 정렬
  }, [orders, deals, contactsMaster, searchTerm]);


  // 기존 로직 100% 유지 (고객명단 매칭 포함)
  // 🚨 1. 거래처 클릭 시 상세 정보 로드 (주문서 필터링 + 히스토리 중복제거 + 🚀 [수정] 파일 목록 가져오기 추가)
  const handleClientClick = async (clientId: number | string, clientName: string) => {
    setSelectedClientId(clientId);
    setSelectedClientName(clientName);
    setDetailLoading(true);
    
    try {
      const cleanId = typeof clientId === 'number' ? clientId : 0;
      
      // 🚨 [수정] API 두 곳(히스토리 + 파일보관함)을 동시에 찌릅니다.
      const [detailRes, filesData] = await Promise.all([
        fetch(`${API_BASE_URL}/clients/history/search?id=${cleanId}&name=${encodeURIComponent(clientName)}`),
        crmDataService.getClientFiles(clientName)
      ]);
      
      let detailData = { orders: [], deal_history: [] };
      if (detailRes.ok) {
        detailData = await detailRes.json();
      }

      setClientFiles(Array.isArray(filesData) ? filesData : []);

      // 💡 [주문서] 이름으로 직접 매칭 (가장 확실한 방법)
      const matchedOrders = orders.filter(ord => {
        const oName = (ord.client_name || ord.거래처명 || ord.거래처 || '').trim();
        return oName === clientName.trim();
      });

      // 💡 [히스토리] 중복 제거 로직 (내용, 시간, 작성자가 같으면 1개만)
      // 🚨 [수정] 오직 '엑티비티 히스토리(content)'만 챙깁니다.
      const cleanHistory = (detailData.deal_history || [])
        // 세일즈 엑티비티에서 온 데이터는 무시하고, 내용(content)이 있는 것만 필터링
        .filter((v: any) => v.content) 
        .filter((v: any, i: number, a: any[]) => 
          a.findIndex((t: any) => 
            t.content === v.content && 
            t.created_at === v.created_at && 
            t.editor === v.editor
          ) === i
        )
        .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

      // 💡 [연락처] 매칭
      const contactRes = await fetch(`${API_BASE_URL}/contacts`);
      const allContacts = await contactRes.json();
      const matchedContacts = allContacts.filter((c: any) => {
        const company = (c.company || c.company_name || '').trim();
        return clientName.includes(company) || company.includes(clientName);
      });

      setClientDetail({ 
        orders: matchedOrders, 
        deal_history: cleanHistory, 
        contacts: matchedContacts 
      });

    } catch (error) { 
      console.error("상세 로드 실패:", error); 
    } finally { 
      setDetailLoading(false); 
    }
  };

  // 👇👇 🚨 [수정] 대시보드 피드 연동 (무한루프 방지 및 안전한 자동 클릭) 👇👇
  const [autoClickTarget, setAutoClickTarget] = useState<string | null>(null);


  // 1. 화면 켜질 때 딱 1번만 메모장 확인하고 🚀즉시 찢어버림!
  useEffect(() => {
    const targetClient = sessionStorage.getItem('targetClientSearch');
    if (targetClient) {
      setSearchTerm(targetClient); // 검색창에 이름 세팅
      setAutoClickTarget(targetClient); // 클릭 대기열에 올림
      sessionStorage.removeItem('targetClientSearch'); // 🚨 무한루프 방지: 메모 즉시 파기!
    }
  }, []); // 👈 괄호 안을 비워서 무조건 1번만 실행되게 함

  // 2. 서버에서 거래처 명단 데이터가 도착하면, 대기열에 있던 업체를 딱 1번만 클릭!
  useEffect(() => {
    if (autoClickTarget && uniqueClients.length > 0) {
      const matchedClient = uniqueClients.find(c => c.client_name === autoClickTarget);
      if (matchedClient) {
        handleClientClick(matchedClient.id, matchedClient.client_name); // 컴퓨터가 찰칵!
        setAutoClickTarget(null); // 🚨 2번 클릭 안 하도록 대기열 비우기
      }
    }
  }, [uniqueClients, autoClickTarget]);

  // 🚨 2. 주문서 저장
  const handleSaveOrder = async () => {
    if (!newOrder.client_name.trim()) {
      alert("거래처명을 입력해주세요.");
      return;
    }
    if (!newOrder.order_no.trim()) {
      alert("주문번호를 입력해주세요.");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newOrder)
      });
      if (res.ok) {
        alert("주문서가 등록되었습니다.");
        setShowOrderModal(false);
        
        // 🚨 [새로고침 없이 즉시 반영 마법!] 
        const newOrderForUI = { ...newOrder, id: Date.now() }; // 임시 ID 부여
        if (selectedClientName === newOrder.client_name) {
          setClientDetail((prev: any) => ({
            ...prev,
            orders: [newOrderForUI, ...(prev?.orders || [])]
          }));
        }
        setOrders(prev => [newOrderForUI, ...prev]);

        setNewOrder({ order_no: '', order_date: new Date().toISOString().split('T')[0], client_name: '', manager_name: '', note: '', win_price: 0 });
        
        // 백그라운드에서 진짜 DB 데이터로 교체
        fetchAllData(); 
      }
    } catch (error) { console.error(error); }
  };

  // 🚨 3. 상담 메모 저장 (중복 제거를 위해 다시 클릭 유도)
  const handleSaveMemo = async () => {
    if (!quickMemo.trim() || !selectedClientName) return;

    const storedData = localStorage.getItem('ieg_user_profile');
    let realName = "관리자"; // 기본값

    if (storedData) {
      try {
        const userData = JSON.parse(storedData);
        realName = userData.name || userData.user?.name || "관리자";
      } catch (e) {
        console.error("로그인 정보 파싱 실패:", e);
      }
    }

    // 🎯 [핵심] CS 모드가 켜져있으면 이름 앞에 [CS팀] 뱃지 강제 부착!
    const finalEditorName = isCSMode ? `[CS팀] ${realName}` : realName;

    try {
      const res = await fetch(`${API_BASE_URL}/activity/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          deal_id: selectedClientName,
          content: quickMemo,
          activity_type: "상담",
          last_editor: finalEditorName 
        })
      });

      if (res.ok) {
        setQuickMemo("");
        setIsCSMode(false); // 전송 후엔 안전하게 모드 끄기
        handleClientClick(selectedClientId!, selectedClientName);
      }
    } catch (error) { 
      console.error("저장 중 오류 발생:", error); 
    }
  }; // <--- 🚨 여기가 정상적으로 닫혔습니다.

  // 🚨 [신규 추가] 히스토리(피드) 수정 함수 (handleSaveMemo 바깥으로 완전히 분리)
  // 🚨 [수정] 히스토리(피드) 수정 함수 (422 에러 방지용 안전장치 추가)
  const handleUpdateHistory = async (id: any) => {
    // 1. ID 값 확인 (없으면 차단)
    if (id === undefined || id === null) {
      alert("이 메모는 고유 ID가 없어서 수정할 수 없습니다.");
      return;
    }

    if (!editHistoryContent.trim()) return;

    const storedData = localStorage.getItem('ieg_user_profile');
    let realName = "관리자";
    if (storedData) {
      try {
        const userData = JSON.parse(storedData);
        realName = userData.name || userData.user?.name || "관리자";
      } catch (e) { console.error(e); }
    }

    try {
      // 2. 백엔드 규격에 맞게 데이터 포장 (history_id를 무조건 숫자로 변환)
      const payload = {
        history_id: Number(id), // 👈 문자로 넘어와도 숫자로 강제 변환
        new_content: editHistoryContent,
        editor: realName
      };

      console.log("📤 백엔드로 보내는 데이터:", payload);

      const res = await fetch(`${API_BASE_URL}/activity/update`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        setEditingHistoryId(null); 
        handleClientClick(selectedClientId!, selectedClientName); 
      } else {
        // 3. 422 에러 등 백엔드가 거절한 진짜 이유를 화면에 띄워줍니다.
        const errData = await res.json();
        console.error("❌ 서버 에러 상세:", errData);
        alert(`수정 실패: ${JSON.stringify(errData.detail || errData)}`);
      }
    } catch (error) {
      console.error("수정 오류:", error);
    }
  };

  // 🚨 4. 기타 관리 함수들 (수정/삭제)
  const handleUpdateClient = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/clients/${editClientData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editClientData)
      });
      if (res.ok) {
        alert("수정되었습니다.");
        setShowEditClientModal(false);
        
        // 🚨 [새로고침 없이 즉시 반영 마법!] 거래처명, 지역 변경 즉시 반영
        if (selectedClientId === editClientData.id) {
          setSelectedClientName(editClientData.client_name);
        }
        setOrders(prev => prev.map(o => o.client_id === editClientData.id ? { ...o, client_name: editClientData.client_name, region: editClientData.region } : o));
        
        fetchAllData();
      }
    } catch (error) { console.error(error); }
  };

  const handleDeleteClient = async (id: number) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/clients/${id}`, { method: 'DELETE' });
      if (res.ok) { fetchAllData(); }
    } catch (error) { console.error(error); }
  };

  const handleUpdateOrder = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/orders/${editOrderData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editOrderData)
      });
      if (res.ok) {
        setShowEditOrderModal(false);
        
        // 🚨 [새로고침 없이 즉시 반영 마법!]
        setClientDetail((prev: any) => ({
          ...prev,
          orders: prev.orders.map((o: any) => o.id === editOrderData.id ? { ...o, ...editOrderData } : o)
        }));
        setOrders(prev => prev.map(o => o.id === editOrderData.id ? { ...o, ...editOrderData } : o));

        fetchAllData();
      }
    } catch (error) { console.error(error); }
  };

  const handleDeleteOrder = async (id: number) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/orders/${id}`, { method: 'DELETE' });
      if (res.ok) {
        // 🚨 [새로고침 없이 즉시 반영 마법!]
        setClientDetail((prev: any) => ({
          ...prev,
          orders: prev.orders.filter((o: any) => o.id !== id)
        }));
        setOrders(prev => prev.filter(o => o.id !== id));

        fetchAllData();
      }
    } catch (error) { console.error(error); }
  };

  return (
    // 🎨 전체 배경을 연한 회색으로 변경 (#f8fafc -> #f1f5f9)
    <div className="relative flex flex-col h-[calc(100vh-2rem)] bg-[#f1f5f9] p-8 gap-8 font-sans overflow-hidden">
      
      {/* 🔝 상단 영역: 마스터 리스트 (입체감 부여) */}
      <div className="h-[40%] bg-white rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200/60 overflow-hidden flex flex-col shrink-0">
        <div className="px-8 py-5 border-b border-slate-100 flex justify-between items-center bg-white">
          <div className="flex items-center gap-4">
            <div className="p-2.5 bg-slate-900 rounded-xl text-white"><Building2 size={20} /></div>
            <div>
              <h2 className="font-black text-slate-900 text-lg tracking-tight">거래처 관리</h2>
              <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider">Master Client Management</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
             {/* 🚨 상단 네비게이션: 고객관리 탭으로 넘어가는 포탈 버튼! (누구나 보기 가능) */}
             <button 
                onClick={() => onNavigate?.('contacts')} 
                className="flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl text-xs font-black transition-all border border-indigo-100 shadow-sm active:scale-95"
             >
                <UserCircle size={16} /> 전체 고객 관리로 이동
             </button>

             <div className="relative">
                <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input type="text" placeholder="학교명 또는 담당자 검색..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
                  className="pl-11 pr-5 py-2.5 bg-slate-50 border border-slate-200 rounded-2xl text-xs font-bold w-64 outline-none focus:bg-white focus:ring-4 focus:ring-blue-50 focus:border-blue-500 transition-all" />
             </div>

             {/* 🚨 [수정] 자물쇠 채우기: 주문서 엑셀 업로드 */}
             <PermissionGate user={currentUser} action="contacts_edit">
               <button
                 onClick={() => {
                   setUploadFile(null); // 열 때마다 초기화
                   setIsUploadModalOpen(true);
                 }}
                 className="flex items-center gap-2 px-4 py-2.5 bg-emerald-50 text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl text-xs font-black transition-all border border-emerald-100 shadow-sm active:scale-95"
               >
                 <Upload size={14} /> 주문서 엑셀 업로드
               </button>
             </PermissionGate>

             <button onClick={fetchAllData} className="p-2.5 hover:bg-slate-50 rounded-xl border border-slate-200 transition-all active:scale-95">
                <RefreshCw size={18} className={loading ? "animate-spin text-blue-600" : "text-slate-400"} />
             </button>
          </div>
        </div>
        
        <div className="flex-1 overflow-y-auto custom-scrollbar px-6 pb-4">
          <table className="w-full text-left">
            <thead className="sticky top-0 bg-white z-10">
              <tr className="text-slate-400 text-[10px] font-black uppercase tracking-widest">
                <th className="py-4 pl-4 w-[60px]">No.</th>
                <th className="py-4 px-4">거래처명</th>
                <th className="py-4 px-4 text-center">지역 (통합)</th>
                <th className="py-4 px-4 text-center">진행중 영업</th>
                <th className="py-4 px-4 text-center">누적주문</th>
                <th className="py-4 px-4 text-center w-[80px]">관리</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {uniqueClients.map((client, idx) => (
                <tr key={client.id} onClick={() => handleClientClick(client.id, client.client_name)}
                  className={`group cursor-pointer transition-all duration-200 ${selectedClientId === client.id ? 'bg-blue-50/50' : 'hover:bg-slate-50/80'}`}>
                  <td className="py-4 pl-4 font-mono text-[11px] text-slate-400">{idx + 1}</td>
                  <td className={`py-4 px-4 font-black text-[14px] ${selectedClientId === client.id ? 'text-blue-600' : 'text-slate-700'}`}>{client.client_name}</td>
                  <td className="py-4 px-4 text-center text-slate-500 font-bold text-[11px]">{client.region || '-'}</td>
                  <td className="py-4 px-4 text-center">
                    {client.has_deal ? (
                      <span className="w-2 h-2 rounded-full bg-emerald-400 inline-block animate-pulse shadow-[0_0_8px_rgba(52,211,153,0.6)]"></span>
                    ) : <span className="text-slate-300">-</span>}
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className={`px-3 py-1 rounded-full text-[11px] font-black ${selectedClientId === client.id ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600'}`}>
                      {client.order_count}건
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    {typeof client.id === 'number' ? (
                      /* 🚨 [수정] 자물쇠 채우기: 리스트 내 수정/삭제 */
                      <PermissionGate user={currentUser} action="contacts_edit">
                        <div className="flex justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button 
                            onClick={(e) => { e.stopPropagation(); setEditClientData({ id: client.id, client_name: client.client_name, region: client.region || '' }); setShowEditClientModal(true); }}
                            className="p-1.5 text-slate-400 hover:text-blue-600 bg-white rounded-md shadow-sm border border-slate-100" title="수정">
                            <Edit2 size={12}/>
                          </button>
                          <button 
                            onClick={(e) => { e.stopPropagation(); handleDeleteClient(client.id); }}
                            className="p-1.5 text-slate-400 hover:text-rose-600 bg-white rounded-md shadow-sm border border-slate-100" title="삭제">
                            <Trash2 size={12}/>
                          </button>
                        </div>
                      </PermissionGate>
                    ) : <span className="text-[10px] text-slate-300">-</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ⬇️ 하단: 3단 일체형 정보 패널 */}
      <div className="flex-1 flex gap-8 min-h-0">
        {!selectedClientId ? (
          <div className="flex-1 bg-white/40 rounded-[40px] border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400">
             <Building2 size={80} className="mb-6 opacity-10" />
             <p className="font-black text-xl tracking-tight opacity-40">상단 리스트에서 분석할 거래처를 선택하세요</p>
          </div>
        ) : (
          <>
            {/* 1. 주문 내역 */}
            <div className="flex-[0.9] bg-white rounded-[32px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200/60 flex flex-col overflow-hidden">
               <div className="px-7 py-6 border-b border-slate-50 flex items-center justify-between bg-white shrink-0">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-rose-50 text-rose-500 rounded-xl"><ShoppingBag size={18} /></div>
                    <h3 className="font-black text-slate-800 text-[15px]">주문서 내역</h3>
                  </div>
                  {/* 🚨 [수정] 자물쇠 채우기: 주문 직접 추가 버튼 */}
                  <PermissionGate user={currentUser} action="contacts_edit">
                    <button 
                      onClick={() => {
                        setNewOrder(prev => ({ ...prev, client_name: selectedClientName }));
                        setShowOrderModal(true);
                      }}
                      className="p-2 bg-rose-500 text-white hover:bg-rose-600 rounded-xl transition-all shadow-lg active:scale-95"
                    >
                      <Plus size={16} strokeWidth={3} />
                    </button>
                  </PermissionGate>
               </div>
               <div className="flex-1 overflow-y-auto p-6 custom-scrollbar bg-slate-50/20">
                  <div className="space-y-4">
                    {clientDetail?.orders?.map((ord: any, i: number) => (
                      <div key={i} className="p-5 bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-md transition-all group relative">
                         {/* 🚨 [수정] 자물쇠 채우기: 개별 주문 수정/삭제 버튼 */}
                         <PermissionGate user={currentUser} action="contacts_edit">
                           <div className="absolute top-4 right-4 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                             <button onClick={() => { setEditOrderData({ ...ord }); setShowEditOrderModal(true); }} className="p-1.5 text-slate-400 hover:text-blue-600 bg-slate-50 rounded-md" title="수정"><Edit2 size={12}/></button>
                             <button onClick={() => handleDeleteOrder(ord.id)} className="p-1.5 text-slate-400 hover:text-rose-600 bg-slate-50 rounded-md" title="삭제"><Trash2 size={12}/></button>
                           </div>
                         </PermissionGate>

                         <div className="flex justify-between items-center mb-2 pr-12">
                            <span className="text-[10px] font-mono text-slate-400 font-black">{ord.order_date}</span>
                            <div className="text-[10px] font-black text-slate-300 group-hover:text-blue-500 transition-colors">{ord.order_no}</div>
                         </div>
                         <div className="mb-3 mt-1">
                           {ord.note ? (
                             <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-rose-50 text-rose-700 text-[11px] font-black border border-rose-100 leading-tight">
                               📍 {ord.note}
                             </span>
                           ) : (
                             <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-slate-50 text-slate-400 text-[11px] font-bold border border-slate-100">
                               본사 일괄 납품
                             </span>
                           )}
                         </div>
                         <div className="pt-3 border-t border-slate-50 flex justify-end">
                           <span className="text-[14px] font-black text-slate-900 font-mono">
                             ₩{(ord.win_price || 0).toLocaleString()}
                           </span>
                         </div>
                      </div>
                    ))}
                  </div>
               </div>
            </div>

            {/* 2. 영업 히스토리 & 🚨 파일함 (슬라이딩 밀어내기 구조) */}
            <div className="flex-[1.3] flex gap-4 min-w-0 transition-all duration-500 ease-in-out">
               {/* 타임라인 메인 보드 */}
               <div 
                 className={`flex-1 bg-white rounded-[32px] shadow-sm border-2 flex flex-col overflow-hidden transition-all duration-300 ${isDragging ? 'border-blue-500 ring-8 ring-blue-50' : 'border-blue-500/20'}`}
                 onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                 onDragLeave={() => setIsDragging(false)}
                 onDrop={handleFileDrop}
               >
                 <div className="px-7 py-5 border-b border-slate-100 bg-slate-900 flex justify-between items-center shrink-0">
                    <div className="flex items-center gap-3 text-white">
                      <History size={20} className="text-blue-400" />
                      <h3 className="font-black text-[15px]">{selectedClientName} 타임라인</h3>
                    </div>
                    <div className="flex items-center gap-2">
                      <PermissionGate user={currentUser} action="cs_edit">
                        <button onClick={() => setShowCSModal(true)} className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-500 text-white text-[11px] font-black rounded-lg transition-colors shadow-sm active:scale-95">
                          <Wrench size={14} /> CS 정식 활동 추가
                        </button>
                      </PermissionGate>
                      <span className="text-[10px] font-black text-blue-300 bg-blue-500/20 px-2 py-1 rounded-full border border-blue-500/30">LIVE</span>
                      {/* 🚨 [신규] 파일함 토글 버튼 */}
                      <button 
                        onClick={() => setShowFileCabinet(!showFileCabinet)}
                        className={`p-2 rounded-lg transition-all ml-1 ${showFileCabinet ? 'bg-blue-500 text-white shadow-lg shadow-blue-200' : 'bg-slate-800 text-slate-400 hover:text-white hover:bg-slate-700'}`}
                        title="파일 보관함 열기"
                      >
                        <FolderOpen size={16} />
                      </button>
                    </div>
                  </div>

                  <div className="flex-1 overflow-y-auto p-6 bg-white custom-scrollbar">
                    {clientDetail?.deal_history?.length > 0 ? (
                      <div className="border-l-2 border-slate-100 ml-2 pl-6 space-y-6">
                        {clientDetail.deal_history.map((hist: any, i: number) => {
                          const isCS = hist.editor?.includes('[CS팀]');
                          const isEditing = editingHistoryId === hist.id; 

                          return (
                            <div key={i} className="relative group">
                              <div className={`absolute -left-[31px] top-1 w-3 h-3 bg-white border-2 rounded-full z-10 ${isCS ? 'border-purple-600' : 'border-blue-600'}`} />
                              
                              <div className="flex items-center justify-between mb-1">
                                <div className="flex items-center gap-2">
                                  <span className={`text-[10px] font-black px-1.5 py-0.5 rounded ${isCS ? 'text-white bg-purple-600 shadow-sm' : 'text-blue-600 bg-blue-50'}`}>
                                    {hist.editor}
                                  </span>
                                  <span className="text-[10px] font-bold text-slate-400">{hist.created_at?.substring(2, 16)}</span>
                                </div>
                                
                                {/* 🛠️ 수정 버튼 (수정 중이 아닐 때만 노출) */}
                                {!isEditing && (
                                  <PermissionGate user={currentUser} action="contacts_edit">
                                    <button 
                                      onClick={() => { setEditingHistoryId(hist.id); setEditHistoryContent(hist.content); }}
                                      className="opacity-0 group-hover:opacity-100 p-1 text-slate-400 hover:text-blue-600 transition-all"
                                      title="내용 수정"
                                    >
                                      <Edit2 size={12} />
                                    </button>
                                  </PermissionGate>
                                )}
                              </div>

                              {isEditing ? (
                                <div className="space-y-2 animate-in fade-in duration-200">
                                  <textarea 
                                    value={editHistoryContent}
                                    onChange={(e) => setEditHistoryContent(e.target.value)}
                                    className="w-full p-3 rounded-2xl border-2 border-blue-400 text-[12px] font-bold outline-none shadow-inner"
                                    rows={3}
                                  />
                                  <div className="flex justify-end gap-1">
                                    <button onClick={() => setEditingHistoryId(null)} className="px-3 py-1 text-[10px] font-black bg-slate-100 text-slate-500 rounded-lg hover:bg-slate-200">취소</button>
                                    <button onClick={() => handleUpdateHistory(hist.id)} className="px-3 py-1 text-[10px] font-black bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-md">저장하기</button>
                                  </div>
                                </div>
                              ) : (
                                <div className={`whitespace-pre-wrap p-3.5 rounded-2xl border text-[12px] font-bold text-slate-700 leading-relaxed transition-all ${isCS ? 'bg-purple-50/30 border-purple-100 group-hover:bg-purple-50' : 'bg-slate-50 border-slate-100 group-hover:bg-blue-50/30'}`}>
                                  {hist.content}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="h-full flex flex-col items-center justify-center text-slate-300 opacity-50 py-10">
                        <MessageSquare size={40} className="mb-2" />
                        <p className="text-sm font-black text-center">여기에 파일을 끌어다 놓으시거나<br/>하단에 상담 메모를 입력하세요.</p>
                      </div>
                    )}
                  </div>

                  <div className="p-4 bg-slate-50 border-t border-slate-100 shrink-0 flex flex-col gap-2">
                    <div className="flex justify-end">
                      <button
                        onClick={() => setIsCSMode(!isCSMode)}
                        className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-black border transition-all ${isCSMode ? 'bg-purple-100 text-purple-700 border-purple-300 shadow-inner' : 'bg-white text-slate-400 border-slate-200 hover:bg-slate-50'}`}
                      >
                        <div className={`w-2 h-2 rounded-full ${isCSMode ? 'bg-purple-600 animate-pulse' : 'bg-slate-300'}`} />
                        {isCSMode ? '🎧 CS팀 메모 모드 ON' : 'CS팀 메모 남기기'}
                      </button>
                    </div>
                    <div className={`bg-white rounded-2xl p-2 pl-4 shadow-sm border flex items-center gap-2 transition-all ${isCSMode ? 'border-purple-300 ring-2 ring-purple-50' : 'border-slate-200 focus-within:ring-2 focus-within:ring-blue-100'}`}>
                      <textarea 
                        value={quickMemo} 
                        onChange={e => setQuickMemo(e.target.value)} 
                        placeholder={isCSMode ? "CS팀 활동 내역이나 전달사항을 남겨주세요..." : "영업 상담 메모를 입력하세요..."}
                        className="flex-1 h-10 py-2 text-[12px] font-bold text-slate-700 outline-none resize-none bg-transparent placeholder:text-slate-300 custom-scrollbar" 
                      />
                      <button 
                        onClick={handleSaveMemo} 
                        disabled={!quickMemo.trim()}
                        className={`p-2.5 text-white rounded-xl disabled:bg-slate-300 transition-all active:scale-95 ${isCSMode ? 'bg-purple-600 hover:bg-purple-700 shadow-purple-200' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-200'} shadow-lg`}
                      >
                        <Send size={16} strokeWidth={3} />
                      </button>
                    </div>
                  </div>
               </div>

               {/* 🚨 [신규] 슬라이딩 파일 보관함 (밀어내기 방식: shrink-0 추가) */}
               {showFileCabinet && (
                  <div className="w-[280px] shrink-0 bg-white rounded-[32px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200 flex flex-col overflow-hidden animate-in slide-in-from-right duration-300">
                    <div className="px-5 py-4 bg-blue-600 text-white flex justify-between items-center shrink-0">
                      <div className="flex items-center gap-2">
                        <FolderOpen size={16} />
                        <h3 className="font-black text-[13px]">파일 보관함</h3>
                      </div>
                      <button onClick={() => setShowFileCabinet(false)} className="hover:bg-white/20 rounded-lg p-1"><X size={16}/></button>
                    </div>
                    <div className="flex-1 overflow-y-auto p-4 custom-scrollbar bg-slate-50/30 space-y-2">
                      {clientFiles.length > 0 ? (
                        clientFiles.map((file, idx) => (
                          <div key={idx} className="flex items-center justify-between p-3 bg-white rounded-2xl border border-slate-100 shadow-sm hover:border-blue-400 transition-all group">
                            <div className="flex items-center gap-2 min-w-0">
                              <FileText size={14} className="text-slate-400 shrink-0" />
                              <span className="text-[11px] font-bold text-slate-700 truncate" title={file.name}>{file.name}</span>
                            </div>
                            
                            {/* 🚨 [수정] 다운로드 버튼과 휴지통 버튼 나란히 배치 */}
                            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                              <button 
                                onClick={() => window.open(`${API_BASE_URL}/clients/files/download?path=${encodeURIComponent(file.path)}`)} 
                                className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                title="다운로드"
                              >
                                <Download size={14} />
                              </button>
                              
                              {/* 🚨 삭제 버튼 (권한이 있는 사람만 볼 수 있음) */}
                              <PermissionGate user={currentUser} action="contacts_edit">
                                <button 
                                  onClick={() => handleDeleteFile(file.path, file.name)} 
                                  className="p-1.5 text-rose-500 hover:bg-rose-50 rounded-lg transition-colors"
                                  title="삭제"
                                >
                                  <Trash2 size={14} />
                                </button>
                              </PermissionGate>
                            </div>

                          </div>
                        ))
                      ) : (
                        <div className="h-full flex flex-col items-center justify-center opacity-30 py-10">
                          <FileUp size={32} className="mb-2" />
                          <p className="text-[10px] font-black uppercase text-center"></p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
            </div>

            {/* 3. 소속 담당자 명단 */}
            <div className="flex-[0.8] bg-white rounded-[32px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200/60 flex flex-col overflow-hidden">
               <div className="px-7 py-6 border-b border-slate-100 flex justify-between items-center bg-white shrink-0">
                  <div className="flex items-center gap-3 text-emerald-600">
                    <Users size={20} />
                    <h3 className="font-black text-slate-900 text-[15px]">학과별 담당자</h3>
                  </div>
                  {/* 🚨 [수정] 자물쇠 채우기: 학과별 담당자 추가 버튼 */}
                  <PermissionGate user={currentUser} action="contacts_edit">
                    <button onClick={() => onNavigate?.('contacts')} className="p-2.5 bg-emerald-50 text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl transition-all border border-emerald-100">
                      <Plus size={16} strokeWidth={3} />
                    </button>
                  </PermissionGate>
               </div>
               
               <div className="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-6 bg-slate-50/20">
                  {clientDetail?.contacts?.length > 0 ? (
                    Object.entries(
                      clientDetail.contacts.reduce((acc: any, curr: any) => {
                        const dept = curr.department || curr.industry || '미분류 학과/부서';
                        if (!acc[dept]) acc[dept] = [];
                        acc[dept].push(curr);
                        return acc;
                      }, {})
                    ).map(([dept, members]: [string, any]) => (
                      <div key={dept} className="space-y-3">
                        <div className="flex items-center gap-2 mb-1">
                          <div className="h-1.5 w-1.5 bg-emerald-400 rounded-full" />
                          <p className="text-[11px] font-black text-emerald-600 uppercase tracking-tighter">{dept}</p>
                        </div>
                        {members.map((m: any, idx: number) => {
                          const rawName = m.contactPerson || m.contact_person || m.name;
                          const displayName = (!rawName || rawName === '-') ? '이름 미상' : rawName;

                          return (
                            <div key={idx} className="p-4 bg-white border border-slate-100 rounded-2xl shadow-sm group hover:border-emerald-400 hover:translate-x-1 transition-all">
                               <div className="flex justify-between items-start">
                                  <div>
                                     <p className="text-[13px] font-black text-slate-800">{displayName}</p>
                                  </div>
                                  <button className="p-1.5 bg-slate-50 rounded-lg text-slate-300 hover:text-emerald-500 transition-colors">
                                     <MessageSquare size={14} />
                                  </button>
                               </div>
                               <p className="text-[10px] text-slate-500 font-bold mt-3 font-mono">📞 {m.phone || m.email || '-'}</p>
                            </div>
                          );
                        })}
                      </div>
                    ))
                  ) : (
                    <div className="h-full flex flex-col items-center justify-center opacity-20 py-10"><Users size={40} /><p className="text-[11px] font-black mt-3 uppercase tracking-widest">Empty Contacts</p></div>
                  )}
               </div>
            </div>
          </>
        )}
      </div>

      {/* 모달창들 */}
      {showOrderModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden animate-fade-in-up">
            <div className="px-8 py-6 bg-slate-900 text-white flex justify-between items-center">
              <div>
                <h3 className="font-black text-lg">신규 주문서 등록</h3>
                <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Manual Order Entry</p>
              </div>
              <button onClick={() => setShowOrderModal(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={20}/></button>
            </div>
            
            <div className="p-8 space-y-5">
              <div className="space-y-1.5">
                <label className="text-[11px] font-black text-slate-400 uppercase">거래처명 (필수)</label>
                <input type="text" value={newOrder.client_name} onChange={e => setNewOrder({...newOrder, client_name: e.target.value})} 
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold focus:ring-4 focus:ring-blue-50 outline-none transition-all"/>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문일자</label>
                  <input type="date" value={newOrder.order_date} onChange={e => setNewOrder({...newOrder, order_date: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none"/>
                </div>
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문번호</label>
                  <input type="text" placeholder="필수 입력" value={newOrder.order_no} onChange={e => setNewOrder({...newOrder, order_no: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none"/>
                </div>
              </div>

              {/* 🚨 [추가] 담당자와 금액을 2열 Grid로 묶어서 깔끔하게 배치 */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">고객 담당자</label>
                  <input type="text" placeholder="성함 및 직함" value={newOrder.manager_name} onChange={e => setNewOrder({...newOrder, manager_name: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none"/>
                </div>
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문 금액 (₩)</label>
                  <input type="number" placeholder="예: 1500000" value={newOrder.win_price || ''} onChange={e => setNewOrder({...newOrder, win_price: Number(e.target.value)})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none text-right font-mono focus:ring-4 focus:ring-blue-50 transition-all"/>
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="text-[11px] font-black text-slate-400 uppercase">비고 (특이사항)</label>
                <textarea placeholder="프로젝트명 또는 납품 현장명" value={newOrder.note} onChange={e => setNewOrder({...newOrder, note: e.target.value})} 
                  className="w-full h-24 px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none resize-none"/>
              </div>

              <button onClick={handleSaveOrder} 
                className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black text-sm shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 flex items-center justify-center gap-2 mt-2">
                <ShoppingBag size={18}/> 주문서 저장하기
              </button>
            </div>
          </div>
        </div>
      )}

      {isUploadModalOpen && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
          <div className="w-[460px] bg-white rounded-2xl shadow-2xl border border-slate-200 p-6">
            <h3 className="text-lg font-bold text-slate-800 mb-4">주문서 엑셀 업로드</h3>
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={(e) => setUploadFile(e.target.files?.[0] || null)}
              className="w-full text-sm text-slate-700 file:mr-3 file:px-3 file:py-1.5 file:rounded-lg file:border file:border-slate-300 file:bg-slate-50 file:font-bold"
            />
            <p className="text-xs text-slate-500 mt-2">엑셀 파일(.xlsx, .xls)을 파일 선택 창이나 위 버튼에 드래그 앤 드롭 하세요.</p>
            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => setIsUploadModalOpen(false)}
                disabled={isUploading}
                className="px-4 py-2 rounded-lg bg-slate-100 text-slate-700 text-sm font-bold hover:bg-slate-200 disabled:opacity-50"
              >
                취소
              </button>
              <button
                onClick={handleConfirmUpload}
                disabled={isUploading}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-bold hover:bg-blue-700 disabled:opacity-50"
              >
                {isUploading ? '업로드 중...' : '업로드하기'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditClientModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-sm rounded-[32px] shadow-2xl overflow-hidden">
            <div className="px-8 py-6 bg-slate-900 text-white flex justify-between items-center">
              <h3 className="font-black text-lg">거래처 정보 수정</h3>
              <button onClick={() => setShowEditClientModal(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={20}/></button>
            </div>
            <div className="p-8 space-y-5">
              <div className="space-y-1.5">
                <label className="text-[11px] font-black text-slate-400 uppercase">거래처명</label>
                <input type="text" value={editClientData.client_name} onChange={e => setEditClientData({...editClientData, client_name: e.target.value})} 
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20"/>
              </div>
              <div className="space-y-1.5">
                <label className="text-[11px] font-black text-slate-400 uppercase">지역 (권역)</label>
                <input type="text" value={editClientData.region} onChange={e => setEditClientData({...editClientData, region: e.target.value})} 
                  className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20"/>
              </div>
              <button onClick={handleUpdateClient} className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black text-sm shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 mt-2">
                수정 완료
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditOrderModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden">
            <div className="px-8 py-6 bg-slate-900 text-white flex justify-between items-center">
              <h3 className="font-black text-lg">주문서 정보 수정</h3>
              <button onClick={() => setShowEditOrderModal(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={20}/></button>
            </div>
            <div className="p-8 space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문일자</label>
                  <input type="date" value={editOrderData.order_date} onChange={e => setEditOrderData({...editOrderData, order_date: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20"/>
                </div>
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문번호</label>
                  <input type="text" value={editOrderData.order_no} onChange={e => setEditOrderData({...editOrderData, order_no: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20"/>
                </div>
              </div>

              {/* 🚨 [추가] 수정 모달에서도 담당자와 금액을 2열 Grid로 묶어서 배치 */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">고객 담당자</label>
                  <input type="text" value={editOrderData.manager_name} onChange={e => setEditOrderData({...editOrderData, manager_name: e.target.value})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20"/>
                </div>
                <div className="space-y-1.5">
                  <label className="text-[11px] font-black text-slate-400 uppercase">주문 금액 (₩)</label>
                  <input type="number" value={editOrderData.win_price || ''} onChange={e => setEditOrderData({...editOrderData, win_price: Number(e.target.value)})} 
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none focus:ring-2 focus:ring-blue-500/20 font-mono text-right"/>
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="text-[11px] font-black text-slate-400 uppercase">비고 (특이사항)</label>
                <textarea value={editOrderData.note} onChange={e => setEditOrderData({...editOrderData, note: e.target.value})} 
                  className="w-full h-24 px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-[13px] font-bold outline-none resize-none focus:ring-2 focus:ring-blue-500/20"/>
              </div>
              <button onClick={handleUpdateOrder} className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black text-sm shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 mt-2">
                수정 완료
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🚨 CS 정식 접수 모달 */}
      <CSActivityModal 
        isOpen={showCSModal} 
        onClose={() => setShowCSModal(false)} 
        clientName={selectedClientName} 
        onSuccess={() => handleClientClick(selectedClientId!, selectedClientName)} 
      />

    </div>
  );
}